import React from "react";
import { Tag, Tooltip } from "antd";

export const newApps = (leng) => {
  return [
    {
      title: () => {
        return (
          <>
            App Name <Tag color="processing">{leng}</Tag>
          </>
        );
      },
      dataIndex: "current_name",
      key: "current_name",
      fixed: "left",
      sorter: (a, b) =>
        a.current_name ? a.current_name.localeCompare(b.current_name) : 1,
      responsive: ["sm"],
      width: "40%",
    },
    {
      title: "Category Name",
      dataIndex: "category_name",
      key: "category_name",
      fixed: "left",
      sorter: (a, b) =>
        a.category_name ? a.category_name.localeCompare(b.category_name) : 1,
      responsive: ["sm"],
      width: "40%",
    },
    {
      title: () => {
        return (
          <Tooltip placement="left" title={"Cloud Confidence Level"}>
            CCL
          </Tooltip>
        );
      },
      dataIndex: "ccl",
      key: "ccl",
      fixed: "left",
      sorter: (a, b) => (a.ccl ? a.ccl.localeCompare(b.ccl) : 1),
      // showSorterTooltip: false,
      responsive: ["sm"],
      width: "20%",
    },
  ];
};

export const chngCclApps = (leng) => {
  return [
    {
      title: () => {
        return (
          <>
            App Name <Tag color="processing">{leng}</Tag>
          </>
        );
      },
      dataIndex: "current_name",
      key: "current_name",
      fixed: "left",
      sorter: (a, b) =>
        a.current_name ? a.current_name.localeCompare(b.current_name) : 1,
      responsive: ["sm"],
      width: "35%",
    },
    {
      title: "Category Name",
      dataIndex: "category_name",
      key: "category_name",
      fixed: "left",
      sorter: (a, b) =>
        a.category_name ? a.category_name.localeCompare(b.category_name) : 1,
      responsive: ["sm"],
      width: "35%",
    },
    {
      title: () => {
        return (
          <Tooltip placement="left" title={" Old Cloud Confidence Level"}>
            Old CCL
          </Tooltip>
        );
      },
      dataIndex: "oldccl",
      key: "oldccl",
      fixed: "left",
      sorter: (a, b) => (a.oldccl ? a.oldccl.localeCompare(b.oldccl) : 1),
      responsive: ["sm"],
      width: "15%",
    },
    {
      title: () => {
        return (
          <Tooltip placement="left" title={" New Cloud Confidence Level"}>
            New CCL
          </Tooltip>
        );
      },
      dataIndex: "newccl",
      key: "newccl",
      fixed: "left",
      sorter: (a, b) => (a.newccl ? a.newccl.localeCompare(b.newccl) : 1),
      responsive: ["sm"],
      width: "15%",
    },
  ];
};

export const newDomain = (leng) => {
  return [
    {
      title: () => {
        return (
          <>
            App Name <Tag color="processing">{leng}</Tag>
          </>
        );
      },
      dataIndex: "current_name",
      key: "current_name",
      fixed: "left",
      sorter: (a, b) =>
        a.current_name ? a.current_name.localeCompare(b.current_name) : 1,
      responsive: ["sm"],
      width: "15%",
    },
    {
      title: "Category",
      dataIndex: "category_name",
      key: "category_name",
      fixed: "left",
      sorter: (a, b) =>
        a.category_name ? a.category_name.localeCompare(b.category_name) : 1,
      responsive: ["sm"],
      width: "15%",
    },
    {
      title: "Domain",
      dataIndex: "domain_name",
      key: "domain_name",
      fixed: "left",
      sorter: (a, b) =>
        a.domain_name ? a.domain_name.localeCompare(b.domain_name) : 1,
      responsive: ["sm"],
      width: "15%",
    },
  ];
};

export const catChngApps = (leng) => {
  return [
    {
      title: () => {
        return (
          <>
            App Name <Tag color="processing">{leng}</Tag>
          </>
        );
      },
      dataIndex: "current_name",
      key: "current_name",
      fixed: "left",
      sorter: (a, b) =>
        a.current_name ? a.current_name.localeCompare(b.current_name) : 1,
      responsive: ["sm"],
      width: "15%",
    },
    {
      title: "Old Category",
      dataIndex: "old_category",
      key: "old_category",
      fixed: "left",
      sorter: (a, b) =>
        a.old_category ? a.old_category.localeCompare(b.old_category) : 1,
      responsive: ["sm"],
      width: "15%",
    },
    {
      title: "New Category",
      dataIndex: "new_category",
      key: "new_category",
      fixed: "left",
      sorter: (a, b) =>
        a.new_category ? a.new_category.localeCompare(b.new_category) : 1,
      responsive: ["sm"],
      width: "15%",
    },
  ];
};

export const nameChngApps = (leng) => {
  return [
    {
      title: () => {
        return (
          <>
            Old App Name <Tag color="processing">{leng}</Tag>
          </>
        );
      },
      dataIndex: "old_name",
      key: "old_name",
      fixed: "left",
      sorter: (a, b) => (a.old_name ? a.old_name.localeCompare(b.old_name) : 1),
      responsive: ["sm"],
      width: "15%",
    },
    {
      title: "New App Name",
      dataIndex: "new_name",
      key: "new_name",
      fixed: "left",
      sorter: (a, b) => (a.new_name ? a.new_name.localeCompare(b.new_name) : 1),
      responsive: ["sm"],
      width: "15%",
    },
  ];
};

export const breachedApps = (leng) => {
  return [
    {
      title: () => {
        return (
          <>
            App Name <Tag color="processing">{leng}</Tag>
          </>
        );
      },
      dataIndex: "AppName",
      key: "AppName",
      fixed: "left",
      sorter: (a, b) => (a.AppName ? a.AppName.localeCompare(b.AppName) : 1),
      // responsive: ["sm"],
      width: "40%",
    },
    {
      title: "Category Name",
      dataIndex: "categoryName",
      key: "categoryName",
      fixed: "left",
      sorter: (a, b) =>
        a.categoryName ? a.categoryName.localeCompare(b.categoryName) : 1,
      // responsive: ["sm"],
      width: "40%",
    },
    {
      title: "Breached Date",
      dataIndex: "breachedDate",
      key: "breachedDate",
      fixed: "left",
      width: "20%",
      defaultSortOrder: "descend",
      sorter: (a, b) => new Date(a.breachedDate) - new Date(b.breachedDate),
      render: (text, record) => {
        return <>{text !== null ? text : ""}</>;
      },
    },
  ];
};

export const getJs = (rel, prev, sel) => {
  switch (sel) {
    case "new_apps":
      return {
        type: "fetch",
        qry: "fetNewCciApps",
        firstVal: "snapshot_v" + rel + "_0_0",
        secondVal: "snapshot_v" + rel + "_0_0",
        thirdVal: "snapshot_v" + rel + "_0_0",
        fourthVal: "snapshot_v" + rel + "_0_0",
        fifthVal: "snapshot_v" + prev + "_0_0",
      };
    case "new_domains":
      return {
        type: "fetch",
        qry: "fetNewDomain",
        firstVal: "snapshot_v" + rel + "_0_0",
        secondVal: "snapshot_v" + rel + "_0_0",
        thirdVal: "snapshot_v" + rel + "_0_0",
        fourthVal: "snapshot_v" + rel + "_0_0",
        fifthVal: "snapshot_v" + prev + "_0_0",
      };
    case "changed_ccl_apps":
      return {
        type: "fetch",
        qry: "fetChngCclApps",
        firstVal: "snapshot_v" + rel + "_0_0",
        secondVal: "snapshot_v" + rel + "_0_0",
        thirdVal: "snapshot_v" + rel + "_0_0",
        fourthVal: "snapshot_v" + rel + "_0_0",
        fifthVal: "snapshot_v" + prev + "_0_0",
        sixthVal: "snapshot_v" + prev + "_0_0",
        seventhVal: "snapshot_v" + prev + "_0_0",
        eigthVal: "snapshot_v" + prev + "_0_0",
      };
    case "category_changed_apps":
      return {
        type: "fetch",
        qry: "fetCciAppCatUpdate",
        firstVal: "snapshot_v" + rel + "_0_0",
        secondVal: "snapshot_v" + rel + "_0_0",
        thirdVal: "snapshot_v" + rel + "_0_0",
        fourthVal: "snapshot_v" + prev + "_0_0",
        fifthVal: "snapshot_v" + prev + "_0_0",
      };
    case "name_changed_apps":
      return {
        type: "fetch",
        qry: "fetCciChngAppName",
        firstVal: "snapshot_v" + rel + "_0_0",
        secondVal: "snapshot_v" + prev + "_0_0",
      };
    case "breached_apps":
      return {
        type: "fetch",
        qry: "fetBreachApps",
        preProcess: true,
        preProcFunc: "dateProc",
        firstVal: "snapshot_v" + rel + "_0_0",
        secondVal: "snapshot_v" + rel + "_0_0",
        thirdVal: "snapshot_v" + rel + "_0_0",
        fourthVal: "snapshot_v" + rel + "_0_0",
        fifthVal: "snapshot_v" + prev + "_0_0",
      };
    default:
      console.log(`Sorry, we are out of ${sel}.`);
  }
};

export const tabPageCss = {
  padding: "0",
  marginBottom: "0",
};

export const cardCss = { padding: "0", borderStyle: "hidden" };
